<template>
  <div class="container">
    <h1 class="subs-title">{{ id ? adminText('organizationAll.update_a_member_0b4aacaa', 'Update a member') : adminText('organizationAll.create_a_member_80a8ffe3', 'Create a member') }}</h1>
    <div v-if="loading">
      <span class="page-title"> {{ adminText('organizationAll.loading_b04ba49f', 'Loading...') }} </span>
    </div>
    <member-form
      v-else
      :schema="schema"
      :initial-values="membership"
      :organization-slug="organizationSlug"
      :submitting="submitting"
      :initial-membership-plan-id="initialMembershipPlanId"
      @onCreate="handleCreate"
      @onUpdate="handleUpdate"
    />
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import moment from 'moment'
import MemberForm from '@/components/organizations/memberships/forms/MemberForm.vue'
import { GET_ORGANIZATION_BY_SLUG } from '@/graphql/organization.graphql'
import { createAttendeeSchema } from '@/utils'
import {
  CREATE_SPORT_MEMBERSHIP_USER,
  GET_SPORT_MEMBERSHIP_USER,
  UPDATE_SPORT_MEMBERSHIP_USER,
} from '@/graphql/membershipUser.graphql'

const DATE_PARSE_FORMATS = [
  'YYYY-MM-DD',
  'DD.MM.YYYY.',
  'DD.MM.YYYY',
  'DD/MM/YYYY',
  moment.ISO_8601,
]

export default {
  mixins: [OrganizationLocalization],
  name: 'member-container',
  components: { MemberForm },
  props: {
    id: {
      type: String,
      default: null,
    },
    organizationSlug: {
      type: String,
    },
    initialMembershipPlanId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      membership: null,
      schema: {},
      loading: true,
      submitting: false,
    }
  },
  async mounted() {
    await this.getOrganization()
    if (this.id) {
      await this.getMembership(this.id)
    }
  },
  methods: {
    async handleCreate(form) {
      this.submitting = true
      await this.$apollo.mutate({
        mutation: CREATE_SPORT_MEMBERSHIP_USER,
        variables: {
          dto: this.mapFormData(form),
        },
      })

      this.$router.go(-1)
      this.submitting = false
    },
    async handleUpdate(form) {
      this.submitting = true
      await this.$apollo.mutate({
        mutation: UPDATE_SPORT_MEMBERSHIP_USER,
        variables: {
          id: this.id,
          dto: this.mapFormData(form),
        },
      })

      this.$router.go(-1)
      this.submitting = false
    },
    async getMembership(id) {
      this.loading = true
      const { data } = await this.$apollo.query({
        query: GET_SPORT_MEMBERSHIP_USER,
        variables: { id, organizationSlug: this.organizationSlug },
      })

      this.membership = data.getMembershipUserById
      this.normalizeDateFields()
      this.loading = false
    },
    normalizeDateFields() {
      if (!this.membership || !this.membership.fields || !this.schema || !this.schema.attendeeFields) return

      const dateKeys = this.schema.attendeeFields
        .filter(f => f.component === 'date-field')
        .map(f => f.key)

      for (const key of dateKeys) {
        const val = this.membership.fields[key]
        if (!val) continue
        const parsed = moment(val, DATE_PARSE_FORMATS, true)
        if (parsed.isValid()) {
          this.membership.fields[key] = parsed.format('YYYY-MM-DD')
        } else {
          this.membership.fields[key] = null
        }
      }
    },
    async getOrganization() {
      const { data } = await this.$apollo.query({
        query: GET_ORGANIZATION_BY_SLUG,
        variables: { organizationSlug: this.organizationSlug },
      })

      if (data) {
        this.organization = data.getOrganizationBySlug
        if (this.organization.attendeeFields.membershipFields) {
          this.schema = createAttendeeSchema(this.organization.attendeeFields.membershipFields)
        }
      }

      this.loading = false
    },
    mapFormData(data) {
      let payload = {
        fields: {},
      }

      Object.keys(data).forEach(key => {
        if (key === 'membershipPlanId') {
          Object.assign(payload, { [key]: parseInt(data[key]) })
        } else {
          Object.assign(payload.fields, { [key]: data[key] })
        }
      })

      return payload
    },
  },
}
</script>
<style scoped>
.container {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  max-width: 43.75rem;
  row-gap: 2rem;
}

.subs-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
</style>
